import { Module } from 'vuex'

export interface AdminState {
  authenticated: boolean
}

// Simple single-password auth — replace with real API auth later
const ADMIN_PASSWORD = 'hsb@admin2026'
const SESSION_KEY = 'hsb_admin_session'

const admin: Module<AdminState, unknown> = {
  namespaced: true,
  state: () => ({
    authenticated: !!sessionStorage.getItem(SESSION_KEY)
  }),
  getters: {
    isAuthenticated: (s) => s.authenticated
  },
  mutations: {
    SET_AUTH (state, value: boolean) {
      state.authenticated = value
      if (value) sessionStorage.setItem(SESSION_KEY, '1')
      else sessionStorage.removeItem(SESSION_KEY)
    }
  },
  actions: {
    login ({ commit }, password: string): boolean {
      const ok = password === ADMIN_PASSWORD
      if (ok) commit('SET_AUTH', true)
      return ok
    },
    logout ({ commit }) {
      commit('SET_AUTH', false)
    }
  }
}

export default admin
